import React from "react";
import Marquee from "react-fast-marquee";
import "../styles/marquee.css";

const brands = [
  { name: "Toyota", logo: "/brands/toyota.png" },
  { name: "Nissan", logo: "/brands/nissan.png" },
  { name: "Honda", logo: "/brands/honda.png" },
  { name: "Lexus", logo: "/brands/lexus.png" },
  { name: "Mazda", logo: "/brands/mazda.png" },
  { name: "Mitsubishi", logo: "/brands/mitsubishi.png" },
  { name: "Subaru", logo: "/brands/subaru.png" },
  { name: "Suzuki", logo: "/brands/suzuki.png" }
];

function VehicleMarquee() {
  return (
    <div className="brand-marquee">

      <div className="container">

        <h2 className="brand-title">
          Popular Vehicle Brands
        </h2>

        <Marquee
          speed={60}
          gradient={false}
          pauseOnHover={true}
          autoFill={true}
        >

          {brands.map((brand, index) => (
            <div className="brand-item" key={index}>

              <img src={brand.logo} alt={brand.name} />

              <p>{brand.name}</p>

            </div>
          ))}

        </Marquee>

      </div>

    </div>
  );
}

export default VehicleMarquee;